// PostHog im Admin-Dashboard wird initialisiert, aber direkt opt_out_capturing()
// — wir tracken Admin-User bewusst nicht (siehe REQ-admin-dashboard.md, Section 4.1 F).
// Initialisierung trotzdem, damit Embed-Features (Shared-Dashboards) und
// Feature-Flag-Lookups später funktionieren, ohne dass eigene Page-Views
// in den Funnel-Statistiken landen.

import posthog from 'posthog-js';

let initialized = false;

export function initPostHog(): void {
  if (initialized) return;

  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST;
  if (!key || !host) {
    console.warn('PostHog not initialized — VITE_POSTHOG_KEY or VITE_POSTHOG_HOST missing');
    return;
  }

  posthog.init(key, {
    api_host: host,
    defaults: '2026-01-30',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    persistence: 'memory',
  });

  // Admin-Sessions niemals tracken — auch nicht die wenigen Custom-Events,
  // falls jemand versehentlich posthog.capture() aufruft.
  posthog.opt_out_capturing();

  initialized = true;
}

export { posthog };
